/** @format */

import useTimeout from '@common/application/hooks/useTimeout/src/lib/reactUseTimeout';

export default useTimeout;
